import gql from 'graphql-tag';

export const SEND_META_TRACKING_PIXEL = gql`
	mutation SendMetaTrackingPixel($pixelEventData: MetaPixelEventData!) {
		sendMetaConversionData(pixelEventData: $pixelEventData)
	}
`;
